export enum FinishColorOptionsEnum {
  SW = 'SW',
  BM = 'BM',
}
